import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';

export type ResearchAnalyticsSummary = {
  totalArticles: number;
  totalViews: number;
  totalSaves: number;
  totalDismisses: number;
  totalShares: number;
};

export type ResearchAnalyticsArticle = {
  ID: number;
  title: string;
  createDate: string;
  viewCount: number;
  saveCount: number;
  dismissCount: number;
  shareCount: number;
};

export type ResearchAnalyticsArticlesResponse = {
  data: ResearchAnalyticsArticle[];
  totalItems: number;
  page: number;
  pageSize: number;
  pageCount: number;
};

export type ResearchAnalyticsUser = {
  name: string;
  clinicName: string;
  actionDate: string;
  sharedCount?: number;
};

export type ResearchAnalyticsDetailResponse = {
  data: ResearchAnalyticsUser[];
  totalItems: number;
  page: number;
  pageSize: number;
};

const researchAnalyticsService = () => {
  const summary = (params?: {
    search?: string;
    dateFrom?: string;
    dateTo?: string;
  }): Promise<ResearchAnalyticsSummary> => {
    return ChiroUpAPI.get('api', '/research/analytics/summary', {
      queryParams: params || {},
    });
  };

  const articles = (params: {
    search?: string;
    dateFrom?: string;
    dateTo?: string;
    sort?: string;
    sortDir?: string;
    page?: number;
    pageSize?: number;
    metricFilters?: string;
  }): Promise<ResearchAnalyticsArticlesResponse> => {
    return ChiroUpAPI.get('api', '/research/analytics/articles', {
      queryParams: params,
    });
  };

  const articleDetail = (
    newsId: number,
    params?: {
      action?: string;
      sort?: string;
      sortDir?: string;
      page?: number;
      pageSize?: number;
    }
  ): Promise<ResearchAnalyticsDetailResponse> => {
    return ChiroUpAPI.get('api', `/research/analytics/articles/${newsId}`, {
      queryParams: params || {},
    });
  };

  return {
    summary,
    articles,
    articleDetail,
  };
};

export default researchAnalyticsService();
